<template>
  <div id="FoodDiaryList">
    <mu-list class="foods" v-if="hasFoods">
      <mu-list-item class="food" disableRipple v-for="food, foodIndex in foods" :key="`food-item-${foodIndex}`">
        <div class="title" slot="title">
          {{ 'x' + food.servings +' '+ (food.brand_name ? food.brand_name + ' - ' : '') + food.food_name }}
        </div>
        <div class="serving" slot="describe" v-text="food.serving_description"></div>
        <mu-float-button v-if="userId === $store.state.user.scope.user_id" slot="right" class="trash" icon="delete" mini @click.native="deleteFood(food, foodIndex)" />
      </mu-list-item>
    </mu-list>
    <mu-list class="foods" v-if="hasRecipes">
      <mu-list-item class="food" disableRipple v-for="recipe, recipeIndex in recipes" :key="`food-item-${recipeIndex}`">
        <div class="title" slot="title">
          {{ 'x' + recipe.servings +' '+ recipe.name }}{{ recipe.length }}
        </div>
        <mu-float-button v-if="userId === $store.state.user.scope.user_id" slot="right" class="trash" icon="delete" mini @click.native="deleteRecipe(recipe, recipeIndex)" />
      </mu-list-item>
    </mu-list>
    <div class="noFoods" v-if="!hasFoods && !hasRecipes">
      <p v-if="tab !== 'All'">You added no foods for <strong v-text="tab"></strong></p>
    </div>
    <mu-divider />
    <mu-row class="totals">
      <mu-col class="nutrition" v-for="nutrition, nutritionIndex in nutritionalKeys" :key="`nutrition-${nutritionIndex}`" tablet="20" desktop="20" width="20">
        <div class="value" v-text="`${getValueByNutritionKey(nutrition.key).toFixed(1)}${nutrition.unit}`"></div>
        <div class="label" v-text="nutrition.label"></div>
      </mu-col>
    </mu-row>
  </div>
</template>

<script>

  import FoodApi from '../../../api/Food';
  import './FoodDiary.less';

  export default {
    props: {
      userId: {
        type: Number,
        default: 0
      },
      tab: {
        type: String,
        required: true,
      },
      foods: {
        type: Array,
        required: true
      },
      recipes: {
        type: Array,
        required: true
      },
      totals: {
        type: Object,
        required: true
      }
    },
    name: 'food-dairy-tab',
    data() {
      return {
        nutritionalKeys: [
          { key : "carbohydrate", label : "Carbs", unit : "g" },
          { key : "fat", label : "Fat", unit : "g" },
          { key : "protein", label : "Protein", unit : "g" },
          { key : "sugar", label : "Sugar", unit : "g" },
          { key : "calories", label : "Cals", unit : "kcal" },
        ]
      }
    },
    methods: {
      getValueByNutritionKey(key) {
        let self = this;
        return self.totals[key];
      },
      deleteFood(food, foodIndex) {
        let self = this;
        self.$alert({
          title: "Are you sure?",
          text: "Are you sure you wish to delete this food",
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
        })
        .then(() => {
          food.foodIndex = foodIndex;
          self.processDeleteFood(food);
        }).catch(() => {

        })
      },
      processDeleteFood(food) {
        let self = this;
        FoodApi.deleteFood(food.food_id).then(response => {
          if(response.data.complete) {
            self.$emit('onDelete', food);
            self.$toastr.success(response.data.message);
          }
        }).catch(error => {
          let message = "";
          if(error.response.data.error) {
            message = error.response.data.message;
          } else {
            message = 'Error deleting food';
          }
          self.$toastr.error(message);
        });
      },
      deleteRecipe(recipe, recipeIndex) {
        let self = this;
        self.$alert({
          title: "Are you sure?",
          text: "Are you sure you wish to delete this recipe",
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
        })
        .then(() => {
          recipe.recipeIndex = recipeIndex;
          self.processDeleteRecipe(recipe);
        }).catch(() => {

        })
      },
      processDeleteRecipe(recipe) {
        let self = this;
        FoodApi.deleteRecipe(recipe.id).then(response => {
          if(response.data.complete) {
            self.$emit('onDelete', recipe);
            self.$toastr.success(response.data.message);
          }
        }).catch(error => {
          let message = "";
          if(error.response.data.error) {
            message = error.response.data.message;
          } else {
            message = 'Error deleting food';
          }
          self.$toastr.error(message);
        });
      }
    },

    computed: {
      hasFoods() {
        let self = this;
        return self.foods.length > 0;
      },
      hasRecipes() {
        let self = this;
        return self.recipes.length > 0;
      }
    }
  }

</script>



// WEBPACK FOOTER //
// FoodDiaryTab.vue?a0369476